import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Content from "../../commons/components/content"
import PartnersScreen from "./PartnersScreen/partnersScreen";
import UsersScreen from './UsersScreen/usersScreen';
import EditUserScreen from "./EditUserScreen/editUserScreen";

import { accessManagementResetState } from '../../store/actions/accessManagementActions';

function AccessManagement(props) {
    const { showPartners, showUsers, showUser } = useSelector((state) => state.accessManagement);
    const dispatch = useDispatch();
    
    useEffect(() => {
        return () => dispatch(accessManagementResetState());
    }, []);

    return (
        <Content>
            { showPartners ? <PartnersScreen /> : null }
            { showUsers ? <UsersScreen /> : null }
            { showUser ? <EditUserScreen /> : null }
        </Content>
    )
}

export default AccessManagement
